import React from 'react';
import {HashRouter as Router, Switch, Route} from "react-router-dom";
import Home from './routes/Home';
import ShopDetailPage from "./routes/ShopDetailPage";
import Register from './routes/Register';
import Login from './routes/Login';
import { ShopContextPrrovider } from './context/ShopContext';
import FrontPage from './routes/CommercialFront';
import Cart from './routes/Cart';
import Dash from './routes/SellerDash';
import Checkout from './routes/Checkout';
import SellerLogin from './routes/SellerLogin';
import SellerReg from './routes/SellerReg';
import Slot from './routes/Slot';
import UpdateProduct from './components/UpdateProduct';
import Service from './components/Services';
import Order from './routes/Orders';
import SOrder from './routes/SOrders';

const App = () => {
    return(
            <div><ShopContextPrrovider>
                <Router>
                <Switch>
                <Route exact path="/user/login" component ={Login}/>
                <Route exact path="/user/register" component ={Register}/>
                <Route exact path="/Home" component ={Home}/>
                <Route exact path="/shops" component ={ShopDetailPage}/>
                <Route exact path="/user/cart" component = {Cart}/>
                <Route exact path="/shops/login" component = {SellerLogin}/>
                <Route exact path="/shops/register" component = {SellerReg}/>
                <Route exact path="/shops/Dash" component ={Dash}/>
                <Route exact path="/shops/order" component = {SOrder}/>
                <Route exact path="/products" component ={UpdateProduct}/>
                <Route exact path="/shops/search" component ={Service}/>
                <Route exact path="/user/order" component = {Order}/>
                <Route exact path="/shops/slot" component = {Slot}/>
                <Route exact path="/user/cart/Checkout" component = {Checkout}/>
                <Route exact path="" component ={FrontPage}/>
        </Switch>
                </Router></ShopContextPrrovider>
            </div>
    ); 
};
export default App;